import { faGithub } from "@fortawesome/free-brands-svg-icons"

export default [
  { icon: ['fab', 'facebook-f'], color: 'facebook', bg: 'white', href: 'https://www.facebook.com/begzodjon.ahrorov.7' },
  { icon: ['fab', 'twitter'], color: 'twitter', bg: 'white', href: 'https://twitter.com/25d47e8987f740b' },
  { icon: ['fab', 'linkedin-in'], color: 'linkedin', bg: 'white', href: 'https://www.linkedin.com/in/bekhzod-akhrorov/' },
  { icon: ['fab', 'medium-m'], color: '700', bg: 'white', href: 'https://medium.com/@Bekhzod_Akhrorov' },
  { icon: faGithub, color: '700', bg: 'white', href: 'https://github.com/Bekhzod96' }
];
